import React from 'react';
import Typography from '@mui/material/Typography';
import { getTypographyColorProps } from './getTypographyColorProps';
import { renderHeadingTextWithEmphasis } from './renderHeadingTextWithEmphasis';

const Heading5 = (props) => {
  const { color, children, ...rest } = props;
  const { typographyColor, colorStyle } = getTypographyColorProps(color);
  const formattedChildren = renderHeadingTextWithEmphasis(children, color);
  return (
    <Typography
      {...rest}
      component='h5'
      color={typographyColor}
      sx={[{
        fontSize: '29px',
        fontWeight: '600',
        lineHeight: '36.45px',
        textTransform: 'capitalize'
      }, colorStyle, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}>
      {formattedChildren}
    </Typography>
  );
};

export default Heading5;
